import instagramConstants from '@/app/instagram/constants';
import { env } from '@/env';

interface User {
  firstName?: string | null;
  first_name?: string | null;
  lastName?: string | null;
  last_name?: string | null;
  email?: string | null;
  jobTitle?: string | null;
  job_title?: string | null;
  avatarUrl?: string | null;
  avatar_url?: string | null;
  userRole?: string | null;
  user_role?: string | null;
}

function getLeadingChar(str: string): string {
  return str?.charAt(0) || '';
}

export function getUserInitials(user: User | null | undefined): string | null {
  const firstName = user?.firstName || user?.first_name || '';
  const lastName = user?.lastName || user?.last_name || '';
  if (!firstName && !lastName) {
    return null;
  }
  return `${getLeadingChar(firstName)}${getLeadingChar(lastName)}`;
}

export function getUserDisplayName(user: User | null | undefined): string {
  if (!user) {
    return 'Unavailable User';
  }
  const firstName = user?.firstName || user?.first_name || '';
  const lastName = user?.lastName || user?.last_name || '';
  return firstName && lastName ? `${firstName} ${lastName}` : (user.email ?? '');
}

export function getFormattedUserName(user: User | null | undefined): string {
  const firstName = user?.firstName || user?.first_name || '';
  const lastName = user?.lastName || user?.last_name || '';
  return firstName && lastName ? `${firstName} ${lastName}` : `${firstName}${lastName}`;
}

export function getUserEmail(user: User | null | undefined): string {
  return user?.email ?? '';
}

export function getUserJobTitle(user: User | null | undefined): string {
  return user?.jobTitle || user?.job_title || '';
}

export function getAvatarUrl(user: User | null | undefined): string | undefined {
  return user?.avatarUrl || user?.avatar_url || undefined;
}

export function getUserRole(user: User | null | undefined): string {
  return user?.user_role || user?.userRole || '';
}

export function validateUserAvatar(url: string | null | undefined): boolean {
  if (!url) return false;
  return url.startsWith(env.prodCdnUrl) || url.startsWith(env.devCdnUrl);
}

export function getNumbersFromString(string: string): string | number {
  if (/\d/.test(string)) return string.replace(/\D/g, '');
  return 0;
}

export function validateRealUser(userName: string | null | undefined): boolean {
  return userName !== 'null' && userName !== instagramConstants.igHashtagUser;
}
